const VOTER_KEY = 'pickything-feedback-voter';
const VOTED_KEY = 'pickything-feedback-voted';
export const ADMIN_KEY_STORAGE = 'pickything-feedback-admin-key';

export function getVoterId() {
  let id = localStorage.getItem(VOTER_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(VOTER_KEY, id);
  }
  return id;
}

export function getVotedIds() {
  try {
    const parsed = JSON.parse(localStorage.getItem(VOTED_KEY) || '[]');
    return Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

export function setVotedIds(ids) {
  localStorage.setItem(VOTED_KEY, JSON.stringify([...new Set(ids)]));
}

export function getAdminKey() {
  return sessionStorage.getItem(ADMIN_KEY_STORAGE) || '';
}

export function setAdminKey(key) {
  if (key) {
    sessionStorage.setItem(ADMIN_KEY_STORAGE, key);
  } else {
    sessionStorage.removeItem(ADMIN_KEY_STORAGE);
  }
}

export async function feedbackRequest(method, path, { body, adminKey } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (adminKey) {
    headers['X-Admin-Key'] = adminKey;
  }
  const response = await fetch('/api/' + path, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined
  });
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }
  if (!response.ok) {
    const error = new Error((data && data.error) || response.statusText || 'Request failed');
    error.status = response.status;
    throw error;
  }
  return data;
}
